module.exports = __webpack_public_path__ + "assets/img/183f-et.svg";